import {
  DashboardState,
  EEditabilityType,
  EProjectType,
  EScreenType,
  ESdChangeReason,
  EUserAccessPart,
  IAuthorizationDto,
  IDisplayItem,
  IDisplayItemComponent,
  IEditability,
  IScreenDesign,
  IVisibility,
  SpecialDIIds,
  ViewPart,
  Visibility
} from "@kuika/kuika-cl-model";
import { ConditionSetType } from "@kuika/kuika-cl-model/src/models/builder.dtos";
import { Guid } from "guid-typescript";
import { connect } from "react-redux";
import { IScreenDesignContextState } from "../../../../contexts/screen-design-context/screen-design-context";
import { ScreenService } from "../../../../services/screen-service";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { getSdInstance } from "../../../../shared/utility/designer-context";
import { duplicateDesignerScreen } from "../../../../shared/utility/designer-screen-actions";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import { PropertyHelper } from "../../../../shared/utility/property-helper";
import { PropertySdHelper } from "../../../../shared/utility/property-sd-helper";
import { ScreenDesignHelper } from "../../../../shared/utility/screen-design-helper";
import { showDomainAccessRequiredModal } from "../../../../store/domain-access-modal/actions";
import { DeleteModal } from "../../../common/delete-modal";
import KuikaCollapsePanel from "../../../ui-kit/kuika-collapse-panel/kuika-collapse-panel";
import KuikaDropdownMenu from "../../../ui-kit/kuika-dropdown-menu/kuika-dropdown-menu";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";
import KuikaTextMedium from "../../../ui-kit/typography/TextMedium/TextMedium";
import { ActionPicker } from "./action-picker";
import { AuthorizationPanel } from "./authorization-panel/authorization-panel";
import { ComponentChildrenSettings } from "./component-children-settings";
import { DocumentParametersComponentPanel } from "./document-parameters-component-panel";
import { EditabilityPanel } from "./editability-panel";
import { FormChildrenTree } from "./form-children-tree";
import { MasterLayoutComponent } from "./master-layout-component";
import { PressEnterPanel } from "./press-enter-panel";
import { PropertyForm } from "./property-form";
import PropertyRowIcon from "./property-row-icon";
import { ReportParametersPanel } from "./report-parameters-panel";
import { ResponsiveDesignToolkit } from "./responsive-design-toolkit";
import { ScreenInputList } from "./screen-input-list";
import { ScreenProperties } from "./screen-properties";
import { ShortcutsPanel } from "./shortcuts-panel";
import { StaticTableOperationsPanel } from "./static-table-operations-panel";
import { Validations } from "./validations";
import { VisibilityPanel } from "./visibility-panel";
import { WatermarkSettingsPanel } from "./watermark-settings-panel";

export interface ISelectedDiPropertiesState {
  isRenaming: boolean;
  renamingId: string;
  triggerScreenDeleteModal: boolean;
  screenToDelete: IScreenDesignContextState;
  menuSelectValue: string;
  isAuthorizationMenuVisible: boolean;
}

export interface ISelectedDiPropertiesProps {
  showDomainAccessRequiredModal: (actionName: string | string[]) => void;
}

class SelectedDiProperties extends PureSdComponent<
  ISelectedDiPropertiesProps & IWithSDProps & IWithContextProp,
  ISelectedDiPropertiesState
> {
  propertyHelper: PropertyHelper;

  propertySdHelper: PropertySdHelper;

  activeParameterPropertyName: string = "";

  constructor(props: ISelectedDiPropertiesProps & IWithSDProps & IWithContextProp) {
    super(props);
    this.propertySdHelper = new PropertySdHelper(this.getScreenDesignContextProviderValues);
    this.propertyHelper = new PropertyHelper();
    const sVar = {
      isRenaming: false,
      renamingId: "",
      triggerScreenDeleteModal: false,
      screenToDelete: {} as IScreenDesignContextState,
      menuSelectValue: "",
      isAuthorizationMenuVisible: false
    };
    this.state = sVar;
  }

  getScreenDesignContextProviderValues = () => {
    return this.props.sd;
  };

  getSelectedKuikaIds = () => {
    if (
      this.props.sd.dashboardState === DashboardState.dataDiagramScheme ||
      this.props.sd.dashboardState === DashboardState.workFlow
    ) {
      return ["-1"];
    }
    return this.props.sd.selectedKuikaIds;
  };

  onVisibilitySaved = (visibility, changeReason?: ESdChangeReason | undefined) => {
    const kuikaId = this.getSelectedKuikaIds()[0];
    this.props.sd.saveVisibilitytoDisplayItem(kuikaId, visibility, changeReason);
  };

  onEditabilitySaved = (editability: IEditability, changeReason?: ESdChangeReason | undefined) => {
    const kuikaId = this.getSelectedKuikaIds()[0];
    this.props.sd.saveEditabilityToDisplayItem(kuikaId, editability, changeReason);
  };

  onPressEnterSaved = (pressEnter) => {
    const sd = this.props.sd.getScreenDesign();
    const kuikaId = this.getSelectedKuikaIds()[0];
    // this.props.sd.saveVisibilitytoDisplayItem(kuikaId, visibility);
  };

  getEditability = (): IEditability => {
    const newEditability: IEditability = {
      editabilityType: EEditabilityType.Enabled,
      condition: {
        id: Guid.create().toString(),
        conditionSet: {
          conditions: [],
          type: ConditionSetType.and
        }
      }
    };

    const sd = this.props.sd.getScreenDesign();
    const selectedDisplayItem = this.props.sd.getSelectedDisplayItem(sd);

    if (!selectedDisplayItem) {
      return newEditability;
    }

    if (selectedDisplayItem.editability) {
      return selectedDisplayItem.editability;
    }

    return newEditability;
  };

  getVisibility = (): IVisibility => {
    const newVisiblity = {
      id: Guid.create().toString(),
      status: "Visible",
      condition: {
        id: Guid.create().toString(),
        conditionSet: {
          conditions: [],
          type: ConditionSetType.and
        }
      }
    };

    const sd = this.props.sd.getScreenDesign();
    const selectedDisplayItem = this.props.sd.getSelectedDisplayItem(sd);
    if (!selectedDisplayItem) {
      return newVisiblity;
    }
    const { item } = selectedDisplayItem!;
    if (item.visibility) {
      return item.visibility;
    }
    return newVisiblity;
  };

  isItemRenamable = () => {
    const di = this.props.sd.screenDesignDictionary[parseInt(this.props.sd.selectedKuikaIds[0], 10)];
    if (di && di.item) {
      const diItem = di.item;
      const compDef = this.props.sd.getComponentDefinition(diItem);
      if (compDef?.isRenamingDisabled === true) return false;
    }
    return true;
  };

  isScreenSelectedForRename = (): boolean => {
    return this.getSelectedDisplayItem()?.id === SpecialDIIds.rootDI && this.state.renamingId === this.props.sd.sdId;
  };

  isDisplayItemSelectedForRename = (): boolean => {
    return this.getSelectedDisplayItem()?.id.toString() === this.state.renamingId;
  };

  getItemName = () => {
    if (this.getSelectedDisplayItem()?.id === SpecialDIIds.rootDI) {
      return this.props?.sd?.sdName;
    }
    return this.getDiFriendlyNameNameByKuikaId(this.props.sd.selectedKuikaIds[0]);
  };

  renameSelectedItem = async (e, sd: IScreenDesignContextState) => {
    e.stopPropagation();

    let renamingId = "";
    if (this.getSelectedDisplayItem()?.id === SpecialDIIds.rootDI) {
      renamingId = sd.sdId;
    } else {
      renamingId = this.props.sd.selectedKuikaIds[0];
    }
    this.setState({ isRenaming: true, renamingId });
  };

  handleNameKeypress = async (e) => {
    try {
      if (e.keyCode === 13) {
        this.handleNameOnBlur(e);
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  };

  handleNameOnBlur = async (e) => {
    const newName = e.target.value;
    if (this.getSelectedDisplayItem()?.id === SpecialDIIds.rootDI) {
      this.changeScreenName(newName);
    } else {
      if (
        ScreenDesignHelper.isDiFriendlyNameUnique(
          this.props.sd.getScreenDesign().displayItems,
          this.props.sd.selectedKuikaIds[0],
          newName
        ) === false
      ) {
        KMainFunctions.displayWarningNotification("This name is not unique. Please retry with another name.");
        this.setState({ isRenaming: false, renamingId: "" });
        return;
      }
      this.changeDiFriendlyName(newName);
    }
  };

  changeDiFriendlyName = (newName: string) => {
    if (newName && newName.length > 0) {
      const sd = this.props.sd.getScreenDesign();
      const di = this.props.sd.screenDesignDictionary[parseInt(this.props.sd.selectedKuikaIds[0], 10)];
      if (di) {
        di.friendlyName = newName;
        this.setState({ isRenaming: false, renamingId: "" }, () => {
          this.props.sd.setScreenDesign(sd, ESdChangeReason.ChangeDiFriendlyName);
        });
      }
    }
  };

  changeScreenName = async (newName: string) => {
    const screenNameRules = /^[A-Za-z][A-Za-z0-9 ]+$/;
    const isScreenNameValid = screenNameRules.test(newName);
    if (!isScreenNameValid) {
      KMainFunctions.displayWarningNotification("Screen Name is invalid");
      newName = this.getItemName();
    }
    try {
      if (newName?.length > 0) {
        await this.props.sd.saveScreen(false, newName);
        this.props?.sd?.setIsScreenWindowReload(true);
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    } finally {
      this.setState({ isRenaming: false, renamingId: "" });
    }
  };

  getSelectedDisplayItem = () => {
    const sd = this.props.sd.getScreenDesign();
    const selectedDisplayItem = this.props.sd.getSelectedDisplayItem(sd);
    return selectedDisplayItem;
  };

  duplicateSelectedItem = async (sd: IScreenDesignContextState) => {
    const accessName = "Screens";
    if (KMainFunctions.isDomainHasAccess(accessName) === false) {
      this.props.showDomainAccessRequiredModal(accessName);
      return;
    }

    this.props.sd.processWithSpinner(async () => {
      try {
        const result = await duplicateDesignerScreen(getSdInstance(), sd.sdId);
        if ("error" in result) {
          throw new Error(result.error);
        }

        if (result.success) {
          KMainFunctions.displaySuccessNotification("Duplicate has been successful.");
          await this.props?.sd?.setIsScreenWindowReload(true);
        }
      } catch (error) {
        KMainFunctions.exceptionHandler(error);
      }
    });
  };

  getDiFriendlyNameNameByKuikaId = (kuikaId: string): string => {
    let result = kuikaId;
    if (kuikaId && kuikaId.length > 0) {
      const di = this.props.sd.screenDesignDictionary[parseInt(kuikaId, 10)];
      if (di?.friendlyName && di.friendlyName.length > 0) {
        result = di.friendlyName;
      }
    }
    return result;
  };

  triggerDeleteModal = (e, sd: IScreenDesignContextState) => {
    e.stopPropagation();
    if (this.props.sd.screenList.length === 1) {
      KMainFunctions.displayWarningNotification("You can't delete last screen of project.");
      return;
    }

    this.setState({ triggerScreenDeleteModal: true, screenToDelete: sd });
  };

  async deleteScreen() {
    try {
      await this.props.sd.saveScreen(true);
      const res = await ScreenService.DeleteCurrentScreen(this.state.screenToDelete.sdId);
      if (res.status === 200) {
        KMainFunctions.displaySuccessNotification(
          `${this.state.screenToDelete.sdName} screen has been deleted successfully.`
        );
        this.props?.sd?.setIsScreenWindowReload(true);
        this.props.sd.loadScreen(res.data);
      }
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
    }
  }

  handleComponentRenamingFocus = (event) => event.target.select();

  setMenuSelectValue = (value) => {
    this.setState({ menuSelectValue: value });
  };

  getDiFormComponentOrOneOfItsParentIsForm = (di: IDisplayItem): IDisplayItem | undefined => {
    if (di?.item?.name === "Form") {
      return di;
    }

    if (di?.id === SpecialDIIds.rootDI || di?.parentId === SpecialDIIds.rootDI) {
      return undefined;
    }

    if (!di?.parentId) {
      return undefined;
    }

    const parentDi = this.props.sd.screenDesignDictionary[di.parentId];

    if (!parentDi) {
      return undefined;
    }

    return this.getDiFormComponentOrOneOfItsParentIsForm(parentDi);
  };

  handleVisibleAuthorizationDropdown = (visible: boolean) => {
    this.setState({ isAuthorizationMenuVisible: visible });
  };

  onClickCopyAuthorizationToClipboard = async () => {
    const screen: IScreenDesign = this.props.sd.getScreenDesign();
    const selectedDisplayItem: IDisplayItem | undefined = this.props.sd.getSelectedDisplayItem(screen);

    if (!selectedDisplayItem) {
      return;
    }

    const authorization: IAuthorizationDto | undefined =
      selectedDisplayItem.id === SpecialDIIds.rootDI ? screen.authorization : selectedDisplayItem.authorization;

    if (authorization) {
      const authorizationJson: string = JSON.stringify(authorization, null, 0);
      this.props.sd.setScreenAuthorizationClipboard(authorizationJson);
      KMainFunctions.displaySuccessNotification("Authorization copied to clipboard");
    }
    this.setState({ isAuthorizationMenuVisible: false });
  };

  onClickPasteAuthorizationFromClipboard = async () => {
    const screen: IScreenDesign = this.props.sd.getScreenDesign();
    const selectedDisplayItem: IDisplayItem | undefined = this.props.sd.getSelectedDisplayItem(screen);

    if (!selectedDisplayItem) {
      return;
    }

    const authorizationJson: string | null = this.props.sd.screenAuthorizationClipboard;
    if (authorizationJson) {
      let authorization: IAuthorizationDto;
      try {
        authorization = JSON.parse(authorizationJson);
      } catch {
        return;
      }
      if (selectedDisplayItem.id === SpecialDIIds.rootDI) {
        screen.authorization = authorization;
      } else {
        selectedDisplayItem.authorization = authorization;
      }

      this.props.sd.setScreenDesign(screen, ESdChangeReason.UpdateAuth);
      KMainFunctions.displaySuccessNotification("Authorization pasted from clipboard");
      this.setState({ isAuthorizationMenuVisible: false });
    }
  };

  render() {
    if (!this.props || !this.props.sd || !KMainFunctions.isArrHasValue(this.props.sd.selectedKuikaIds)) {
      return <></>;
    }

    const selectedDi: IDisplayItem | undefined = this.props.sd.getSelectedDisplayItem(this.props.sd.getScreenDesign());
    let hasValidate: boolean = false;
    const di = this.props.sd.screenDesignDictionary[parseInt(this.props.sd.selectedKuikaIds[0], 10)];
    if (di) {
      const targetComponent: IDisplayItemComponent | undefined = di?.item;
      if (targetComponent !== undefined) {
        const targetComponentDefinition = this.props?.sd?.getComponentDefinition(targetComponent);
        hasValidate = targetComponentDefinition?.hasValidate ?? false;
      }
    }
    const visibility = this.getVisibility();
    const editability = this.getEditability();
    const selectedKuikaIds = this.props.sd.selectedKuikaIds[0];
    const isLayout =
      selectedKuikaIds === SpecialDIIds.rootDI.toString() ||
      selectedKuikaIds === SpecialDIIds.layoutHeaderDI.toString() ||
      selectedKuikaIds === SpecialDIIds.layoutFooterDI.toString() ||
      selectedKuikaIds === SpecialDIIds.layoutLeftDI.toString() ||
      selectedKuikaIds === SpecialDIIds.layoutRightDI.toString();
    // A screen that only ever renders on a device: a Mobile project's screen that is not a WebScreen. Web-only
    // affordances (a physical keyboard, a second browser tab) are hidden for these rather than degraded.
    const isMobileOnlyScreen: boolean =
      this.props.sd.project?.projectType === EProjectType.Mobile && !this.props.sd.getIsWebScreen();

    let formDi: IDisplayItem | undefined;

    if (selectedDi) {
      formDi = this.getDiFormComponentOrOneOfItsParentIsForm(selectedDi);
    }
    const hasUserAccessEditComponent = KMainFunctions.hasUserAccessInWorkspaceByProjectRole(
      EUserAccessPart.CreateComponent,
      this.props.sd.project?.projectAccess
    );
    // A master screen's root has no authorization of its own. Decide that for the whole section, not
    // just its panel: an empty Collapse still draws its border, a stray rule across the properties.
    const showAuthorizationPanel: boolean =
      this.props.sd.getVisibility(ViewPart.AuthorizationPanel) === Visibility.Visible &&
      !(this.props.sd.getIsMasterScreen() && this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString());

    return (
      <>
        {this.props.sd.getVisibility(ViewPart.PropertiesPanel) === Visibility.Visible && (
          <>
            <DeleteModal
              itemName={this.state.screenToDelete.sdName}
              triggerModal={this.state.triggerScreenDeleteModal}
              deleteItem={() => this.deleteScreen()}
              deleteType={"Screen"}
              closeModal={() => this.setState({ triggerScreenDeleteModal: false })}
            />

            <input
              type="hidden"
              value={
                KMainFunctions.isArrHasValue(this.props.sd.selectedKuikaIds) ? this.props.sd.selectedKuikaIds[0] : ""
              }
            ></input>

            {this.props.sd.getVisibility(ViewPart.SdPropertiesPanel) === Visibility.Visible && (
              <>
                <div className="kuika-right-panel__column">
                  {selectedDi && formDi && <FormChildrenTree formDi={formDi} />}
                  {this.props.sd.dashboardState === DashboardState.design &&
                    this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString() &&
                    hasUserAccessEditComponent && <ScreenProperties />}
                  {this.props.sd.dashboardState === DashboardState.reportDesigner &&
                    this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString() &&
                    hasUserAccessEditComponent && (
                      <div className="kuika-right-panel__group">
                        <div className="kuika-right-panel__group-row">
                          <WatermarkSettingsPanel />
                        </div>
                      </div>
                    )}
                  {hasUserAccessEditComponent && (
                    <ComponentChildrenSettings
                      setMenuSelectValue={this.setMenuSelectValue}
                      menuSelectValue={this.state.menuSelectValue}
                      disableChildActions={!!formDi}
                    />
                  )}
                  {!formDi && hasUserAccessEditComponent && <ResponsiveDesignToolkit />}
                  {hasUserAccessEditComponent && (
                    <PropertyForm
                      location="PropertyPanel"
                      kuikaId={this.props.sd.selectedKuikaIds[0]}
                      menuSelectValue={this.state.menuSelectValue}
                    />
                  )}
                  {hasUserAccessEditComponent && <StaticTableOperationsPanel />}
                  {hasUserAccessEditComponent && (
                    <div className="kuika-right-panel__group kuika-right-panel__group--auto-hide">
                      <div className="kuika-right-panel__group-row">
                        <DocumentParametersComponentPanel />
                      </div>
                    </div>
                  )}
                  {hasUserAccessEditComponent && (
                    <>
                      <div className="kuika-right-panel__group">
                        {showAuthorizationPanel && (
                          <div className="kuika-right-panel__group-row">
                            <KuikaCollapsePanel
                              iconPlacement="right"
                              className="kuika-right-panel__collapse kuika-right-panel__collapse-lighter kuika-right-panel__collapse--boxed kuika-right-panel__collapse--authorization"
                              data-testid="authorizationDropdown"
                              data-onboarding-id="kuika-right-panel_authorization_dropdown"
                              items={[
                                {
                                  key: "pnlAuthorization",
                                  label: (
                                    <>
                                      <PropertyRowIcon kind="authorization" />
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          width: "100%"
                                        }}
                                      >
                                        <KuikaTextMedium
                                          style={{
                                            float: "left",
                                            overflow: "hidden",
                                            maxWidth: 148,
                                            textOverflow: "ellipsis"
                                          }}
                                          data-onboarding-id="authorization_panel_header_title"
                                        >
                                          Authorization
                                        </KuikaTextMedium>
                                        <div
                                          onClick={(e) => {
                                            e.stopPropagation();
                                          }}
                                          style={{
                                            display: "flex",
                                            alignItems: "center"
                                          }}
                                        >
                                          <KuikaDropdownMenu
                                            options={[
                                              {
                                                key: "1",
                                                label: "Copy Authorization",
                                                onClick: () => {
                                                  this.onClickCopyAuthorizationToClipboard();
                                                }
                                              },
                                              ...(this.props.sd.screenAuthorizationClipboard
                                                ? [
                                                    {
                                                      key: "2",
                                                      label: "Paste Authorization",
                                                      onClick: () => {
                                                        this.onClickPasteAuthorizationFromClipboard();
                                                      }
                                                    }
                                                  ]
                                                : [])
                                            ]}
                                            open={this.state.isAuthorizationMenuVisible}
                                            setOpen={this.handleVisibleAuthorizationDropdown}
                                            trigger="click"
                                          >
                                            <KuikaSvg
                                              data-testid="authorizationMenuTrigger"
                                              name="dots-vertical"
                                              type="styling-panel-icons"
                                              width={16}
                                              height={16}
                                            />
                                          </KuikaDropdownMenu>
                                        </div>
                                      </div>
                                    </>
                                  ),
                                  children: (
                                    <div className="kuika-right-panel__collapse-body">
                                      <AuthorizationPanel></AuthorizationPanel>
                                    </div>
                                  )
                                }
                              ]}
                            />
                          </div>
                        )}
                        {this.props.sd.selectedKuikaIds[0] !== SpecialDIIds.rootDI.toString() &&
                          selectedDi?.item?.name !== "TableRow" &&
                          selectedDi?.item?.name !== "ChartLabel" && (
                            <div className="kuika-right-panel__group-row">
                              <VisibilityPanel visibility={visibility} onVisibilitySaved={this.onVisibilitySaved} />
                            </div>
                          )}

                        {this.props.sd.selectedKuikaIds[0] !== SpecialDIIds.rootDI.toString() &&
                          this.props.sd.dashboardState !== DashboardState.reportDesigner && (
                            <div className="kuika-right-panel__group-row">
                              <EditabilityPanel
                                editability={editability}
                                onEditabilitySaved={this.onEditabilitySaved}
                              />
                            </div>
                          )}

                        {this.props.sd.getVisibility(ViewPart.PressEnterPanel) === Visibility.Visible &&
                          this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString() && (
                            <div className="kuika-right-panel__group-row">
                              <PressEnterPanel />
                            </div>
                          )}

                        {/* RNM-0165: a keyboard shortcut is a physical-keyboard affordance. React Native core
                            exposes no cross-platform hardware-key event, and neither the Android nor the iOS
                            generator ever lowered ScreenModel.Shortcuts — so in a Mobile project this panel
                            configured nothing on any target. Hidden rather than degraded, the same call
                            ADR-005 §5 made for "New Tab". A WebScreen keeps it: that screen really is web. */}
                        {this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString() &&
                          this.props.sd.dashboardState !== DashboardState.reportDesigner &&
                          !isMobileOnlyScreen && (
                            <div className="kuika-right-panel__group-row">
                              <ShortcutsPanel />
                            </div>
                          )}
                      </div>

                      {this.props.sd.getScreenType() === EScreenType.Master && isLayout === true && (
                        <MasterLayoutComponent />
                      )}
                    </>
                  )}
                  {this.props.sd.dashboardState === DashboardState.reportDesigner &&
                    this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString() && (
                      <>
                        <div className="kuika-right-panel__divider" role="separator" />
                        <ReportParametersPanel />
                      </>
                    )}
                  <div className="kuika-right-panel__divider" role="separator" />
                  <ActionPicker />
                  {hasValidate && this.props.sd.getVisibility(ViewPart.ValidationPanel) === Visibility.Visible && (
                    <>
                      <div className="kuika-right-panel__divider" role="separator" />
                      <Validations />
                    </>
                  )}
                  {this.props.sd.selectedKuikaIds[0] === SpecialDIIds.rootDI.toString() &&
                    !this.props.sd.getScreenStepDataFromProject(this.props.sd.sdId) && (
                      <>
                        <div className="kuika-right-panel__divider" role="separator" />
                        <ScreenInputList />
                      </>
                    )}
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.UpdateValidation ||
      changeReason === ESdChangeReason.UpdateVisibilty ||
      changeReason === ESdChangeReason.UpdateEditability ||
      changeReason === ESdChangeReason.ChangeResponsiveRowColumnSettings ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.ActionDescriptionChanged ||
      changeReason === ESdChangeReason.ActionParameterFixedValueChanged
    ) {
      return true;
    }
    return false;
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    showDomainAccessRequiredModal: (accessName) => dispatch(showDomainAccessRequiredModal(accessName))
  };
};

const selectedDiProperties = connect(
  null,
  mapDispatchToProps
)(withContext<ISelectedDiPropertiesProps>(withSD<ISelectedDiPropertiesProps>(SelectedDiProperties)));
export { selectedDiProperties as SelectedDiProperties };
